import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';

import { SupportFormWrapperComponent } from './support-form-wrapper.component';
import { SupportCategories } from '../../models';
import { AuthService } from '../../services/auth/auth.service';

@Injectable()
export class SupportFormDialog {
  #dialog = inject(DialogService);
  #authService = inject(AuthService);

  open(category: SupportCategories): DialogRef {
    return this.#dialog.open(SupportFormWrapperComponent, {
      category,
      user: this.#authService.getUser(),
    });
  }
}
